export const environment = {
    production: true,
    baseUrl:"https://imretail-backend.listrytech.com/",
    redirectUrl:"",
    recaptcha: "6LfqI0ssAAAAANcgWyty6xs9sFk1mdNCxhOP_FEw"
};